import { Link } from 'react-router-dom';
import type { EncyclopediaEntry } from '@/core/models';
import { EntryIcon } from '@/components/EntryIcon';
import { cn } from '@/lib/cn';

interface EntryReferenceChipProps {
  entry?: EncyclopediaEntry;
  fallbackID: string;
  to: string;
  className?: string;
}

export function EntryReferenceChip({
  entry,
  fallbackID,
  to,
  className,
}: EntryReferenceChipProps) {
  const label = entry?.nameZh ?? fallbackID;

  return (
    <Link
      to={to}
      className={cn(
        'inline-flex min-h-8 items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-700 transition-colors hover:bg-sage/10 hover:text-sage dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-sage/20',
        className,
      )}
    >
      {entry && (
        <span aria-label={`${entry.nameZh} 图标`} className="shrink-0">
          <EntryIcon entry={entry} size={18} className="rounded-md" />
        </span>
      )}
      <span className="max-w-[10rem] truncate">{label}</span>
    </Link>
  );
}
